export default "__VITE_ASSET__XhbA8wdi__"